import React, { useState, useEffect } from 'react'
import {
    Toolbar,
    Button,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core'
import { useGlobalStyles } from '../../../App'
import { userService } from '../../../services/user.service'
import serviceAppService from '../../../services/serviceApp.service'
import TableContentLoadingSpinner from '../../shared/TableContentLoadingSpinner'
import { CreateProductModal } from './CreateProductModal'
import { EditProductModal } from './EditProductModal'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        padding: theme.spacing(2),
    },
    enhancedTableToolbar: {
        width: '100%',

        '& .MuiToolbar-gutters': {
            paddingRight: 16,
        },
    },
    toolBar: {
        float: 'right',
    },
    tableSection: {
        marginTop: 25,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
    toolbarButtons: {
        marginLeft: 'auto',
    },
}))

const headCells = [
    { id: 'parentAppName', label: 'Parent App' },
    { id: 'appName', label: 'App Name' },
]

const Products = () => {
    const classes = useStyles()
    const globalClasses = useGlobalStyles()
    const [tableData, setTableData] = useState()
    const [availableAppList, setAvailableAppList] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true)
    const managedService = userService.getManagedService()

    const [createProductModalOpen, setProductLevelModalOpen] = useState(false)

    const createProductOkClickHandler = formData => {
        ;(async function createAccessLevelAsync() {
            try {
                await serviceAppService
                    .createServiceApp({
                        processEngineServiceId: managedService.id,
                        appId: formData.appId,
                        url: formData.url,
                    })
                    .then(() => {
                        updateTableData()
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }

    const [selectedProduct, setSelectedProduct] = useState()
    const [editProductModalOpen, setEditProductModalOpen] = useState(false)

    const editProductOkClickHandler = formData => {
        console.log(formData)
        ;(async function updateProductAsync() {
            try {
                await serviceAppService
                    .updateServiceApp({
                        serviceAppId: formData.serviceAppId,
                        url: formData.url,
                    })
                    .then(() => {
                        updateTableData()
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }

    const loadAvailableAppsList = () => {
        ;(async function getServiceAsync() {
            try {
                await serviceAppService
                    .getAvailableAppList(managedService.id)
                    .then(result => {
                        setAvailableAppList(result)
                        console.log(result)
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }

    const updateTableData = () => {
        ;(async function getServiceAsync() {
            try {
                setIsLoadingData(true)
                await serviceAppService
                    .getServiceAppList(managedService.id)
                    .then(result => {
                        setTableData(result)
                    })
            } catch (exception) {
                console.log(exception)
            } finally {
                setIsLoadingData(false)
            }
        })()
    }

    useEffect(() => {
        ;(async function updatePageTableDataAsync() {
            try {
                updateTableData()
                loadAvailableAppsList()
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [managedService.id])

    const EnhancedTableToolbar = () => {
        return (
            <div className={classes.enhancedTableToolbar}>
                <Toolbar>
                    {availableAppList.length > 0 && (
                        <Button
                            className={classes.toolbarButtons}
                            data-testid='add-button'
                            onClick={() => setProductLevelModalOpen(true)}
                            variant='contained'
                            color='secondary'>
                            Add
                        </Button>
                    )}
                </Toolbar>
            </div>
        )
    }

    const getTableContent = () => {
        if (isLoadingData) {
            return <TableContentLoadingSpinner />
        }

        return tableData.map(row => (
            <TableRow>
                <TableCell>{row.parentAppName}</TableCell>
                <TableCell>{row.appName}</TableCell>
                <TableCell align='right'>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                            setSelectedProduct(row)
                            setEditProductModalOpen(true)
                        }}>
                        Edit
                    </Button>
                </TableCell>
            </TableRow>
        ))
    }

    return (
        <Paper className={classes.tableWrapper}>
            <div className={classes.tableSection}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                        aria-label='enhanced table'>
                        <TableHead className={globalClasses.tableHeader}>
                            <TableRow>
                                {headCells.map((headCell, index) => (
                                    <TableCell key={'head-cell-' + index}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>{getTableContent()}</TableBody>
                    </Table>
                </TableContainer>
            </div>

            {createProductModalOpen && (
                <CreateProductModal
                    data-testid='create-product-modal'
                    availableAppList={availableAppList}
                    setModalOpen={isOpen => setProductLevelModalOpen(isOpen)}
                    okMethod={createProductOkClickHandler}
                />
            )}

            {editProductModalOpen && (
                <EditProductModal
                    data-testid='edit-product-modal'
                    product={selectedProduct}
                    setModalOpen={isOpen => setEditProductModalOpen(isOpen)}
                    okMethod={editProductOkClickHandler}
                />
            )}
        </Paper>
    )
}

export default Products
